import React from 'react';
import { Star, MapPin, Award, FileText, ShieldCheck, Clock, Wrench } from 'lucide-react';
function StarRow({
  size = 'sm'
}: {
  size?: 'sm' | 'md';
}) {
  const dim = size === 'md' ? 'w-5 h-5' : 'w-4 h-4';
  return <div className="flex items-center gap-0.5" aria-label="5 out of 5 star review" data-id="element-230">
      {[0, 1, 2, 3, 4].map(i => <Star key={i} className={`${dim} text-amber-500 fill-amber-500`} aria-hidden="true" data-id="element-231" />)}
      <span className="sr-only" data-id="element-232">5-star review</span>
    </div>;
}
export function Reviews() {
  const reviews = [{
    label: 'Auto Glass Customer',
    city: '[City]',
    name: '[Customer name]',
    quote: '[Paste real customer review here.]'
  }, {
    label: 'Auto Glass Customer',
    city: '[City]',
    name: '[Customer name]',
    quote: '[Paste real customer review here.]'
  }, {
    label: 'Auto Glass Customer',
    city: '[City]',
    name: '[Customer name]',
    quote: '[Paste real customer review here.]'
  }];
  const proofItems = [{
    icon: Clock,
    text: 'Same-Day Openings May Be Available'
  }, {
    icon: Wrench,
    text: 'Certified Auto Glass Technicians'
  }, {
    icon: ShieldCheck,
    text: 'Works With Most Insurance'
  }, {
    icon: Award,
    text: 'Lifetime Vehicle Glass Workmanship Warranty'
  }, {
    icon: FileText,
    text: 'Free Estimates'
  }, {
    icon: MapPin,
    text: 'Howell, Ann Arbor & Novi'
  }];
  return <section className="py-16 md:py-20 px-4 sm:px-6 lg:px-8 bg-slate-50 border-y border-slate-200" aria-labelledby="reviews-heading" data-id="element-233">
      <div className="max-w-7xl mx-auto" data-id="element-234">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-235">
          <div className="inline-flex items-center gap-2 mb-5" data-id="element-236">
            <StarRow size="md" data-id="element-237" />
            <span className="text-sm font-bold text-slate-900" data-id="element-238">
              5-Star Local Service
            </span>
          </div>
          <h2 id="reviews-heading" className="text-3xl md:text-4xl lg:text-5xl font-black text-slate-900 mb-4 tracking-tight leading-tight" data-id="element-239">
            What Customers Say About{' '}
            <span className="text-brand-red" data-id="element-240">Kosin's Glass</span>
          </h2>
          <p className="text-lg text-slate-600" data-id="element-241">
            When glass breaks unexpectedly, drivers count on Kosin's Glass for
            urgent guidance, clear next steps and professional auto glass repair
            or replacement.
          </p>
        </div>

        {/* Review cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-12" data-id="element-242">
          {reviews.map((review, i) => <article key={i} className="bg-white rounded-xl p-6 sm:p-7 border border-slate-200 shadow-sm flex flex-col" data-id="element-243">
              <div className="flex items-center justify-between mb-4" data-id="element-244">
                <StarRow data-id="element-245" />
                <span className="inline-block bg-brand-redLight text-brand-red px-2.5 py-1 rounded-full text-xs font-bold uppercase tracking-wider" data-id="element-246">
                  {review.label}
                </span>
              </div>
              <blockquote className="text-slate-700 leading-relaxed italic mb-5 flex-grow" data-id="element-247">
                "{review.quote}"
              </blockquote>
              <footer className="pt-4 border-t border-slate-100" data-id="element-248">
                <div className="font-bold text-slate-900 text-sm" data-id="element-249">
                  {review.name}
                </div>
                <div className="text-xs text-slate-500 mt-0.5 flex items-center gap-1" data-id="element-250">
                  <MapPin className="w-3 h-3" data-id="element-251" />
                  {review.city}
                </div>
              </footer>
            </article>)}
        </div>

        {/* Proof-stat strip */}
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5 sm:p-6" data-id="element-252">
          <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3" data-id="element-253">
            {proofItems.map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-254">
                <item.icon className="w-4 h-4 text-brand-red shrink-0" data-id="element-255" />
                <span className="text-sm font-semibold text-slate-700 whitespace-nowrap" data-id="element-256">
                  {item.text}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}